<template>
<div>
  <v-dialog
      class="pa-0 ma-0"
      v-model="sdialog"
    >
    <v-card style="padding: 10px">
      <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="sdialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{item.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="print"
            >
              Print
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      <DisplayHTML :html="doc"  id="helpdoc"/>
      <!-- <div id="helpdoc" v-html="doc" ></div> -->
    </v-card>
  </v-dialog>
  <v-card class="card fill-height" :style="'height:' + height + 'px' ">
    <v-card-title>
      <span class="font-weight-light text-truncate">
        <span v-text="item.id"></span> 
        <h4>{{ item.name }}</h4>
      </span>
    </v-card-title>
    <v-card-subtitle>
      <h3>{{item.cat}}</h3>
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <span v-html="item.desc" class="mr-2"></span>
      <!-- <v-card-actions> -->
      <v-spacer/>
      <!-- <v-chip v-text="'View'" @click="navigate(item.link)" ></v-chip>
      </v-card-actions> -->
      <!-- <v-card-actions class="card-actions" > -->
        <v-btn color="blue" class="viewbutton" @click="navigate(item.link)">View Document</v-btn>
      <!-- </v-card-actions> -->
    </v-card-text>
  </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import DisplayHTML from './DisplayHTML'
export default {
  props: ['item', 'height'],
  components: {
    DisplayHTML
  },
  data: () => ({
    html: '',
    doc: '',
    sdialog: false
  }),
  methods : {
    print() {
      const element = window.document.getElementById("helpdoc");
      const win = window.open("", "_blank");
      win.document.write(`${element.innerHTML}`);
      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
        // cb();
      }, 1000);
    },
    async navigate (url) {
      console.log(url)
      let x = await axios.get(url)
      console.log(x)
      this.doc = x.data
      this.sdialog = true
    }
  }
}
</script>
<style scoped>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
.viewbutton {
  margin-top: 20px;
  margin-left: -5px;
  padding: 5px;
  padding-top: 0px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>